export default function (inputString: string): string {
	const charCodeToRemove = 65533;
	const regex = new RegExp(String.fromCharCode(charCodeToRemove), 'g');
	return inputString.replace(regex, ' ');
}
